<script>
    import { createEventDispatcher } from 'svelte';
    import evidenceService from '../../../services/evidence.js';
    import InlineEdit from '../../../components/inline-edit.svelte';

    export let img_src = '';
    export let evidence = "";

    const handleEditFn = (evidence, attribute) => {
        return ({detail: input}) => {
            let newEvidence = {
                id : evidence.id,
                description: evidence.description
            };
            newEvidence[attribute] = input.value;
            dispatch("edit", newEvidence);
        }
    }

    // InlineEdit options
    let inlineEdit = {
       type : 'text',
       placeholder : 'Agregar descripción',
       lang : {
           'edit'   : "Editar",
           'save'   : "Guardar",
           'cancel' : "Cancelar",
       },
    };

    const dispatch = createEventDispatcher();
</script>
<style>
    img{
        max-width: 800px;
        border-radius: 6px;
        max-height: 390px;
        /*box-shadow: 1px 1px 0px 0px #ccc;*/
        box-shadow: 1px 1px 3px 0px #16121233;
        /*padding: 10px;*/
    }

    .inline-edit {
        padding: 2em;
    }
</style>
<div class="d-flex flex-row justify-content-center align-items-center" style="height: 400px; max-height: 400px;">
    <button on:click={()=>dispatch("pageChange", "back")} style="float: left; width: 3%; background: none; border: none; left: 7px; top: 27%; font-size: 45px;"><i class="fas fa-angle-left"></i></button>
    <div class="d-flex flex-column align-items-center justify-content-center" style="width: 100%;">
        <img src="{img_src}" alt="" />
    </div>
    <button on:click={()=>dispatch("pageChange", "forward")} style="float: right; width: 3%; background: none; border: none; right: 7px; top: 27%; font-size: 45px;"><i class="fas fa-angle-right"></i></button>
</div>
<div class="inline-edit">
    <InlineEdit {...inlineEdit} value={evidence.description} on:save={handleEditFn(evidence, "description")} on:cancel={()=> evidence.description = evidence.description} />
</div>


